import { render } from "./PageNotFound.vue?vue&type=template&id=118d4a9d&scoped=true"
import script from "./PageNotFound.vue?vue&type=script&lang=ts"
export * from "./PageNotFound.vue?vue&type=script&lang=ts"

import "./PageNotFound.vue?vue&type=style&index=0&id=118d4a9d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-118d4a9d"

export default script